export default {
  index:'首頁',
  groupInfo:{
    title:'集團信息',
    recommend:{
      name:'集團介紹',
      desc:''
    },
    history:{
      name:'發展歷程',
      desc:''
    },
    culture:{
      name:'企業文化',
      desc:''
    },
    honor:{
      name:'集團榮譽',
      desc:''
    },
  },
  spread:{
    title:'業務體系',
    goods:{
      name:'虛擬商品采購及交付',
      desc:''
    },
    advert:{
      name:'推廣及廣告服務',
      desc:''
    },
    game:{
      name:'手機遊戲及軟件開發及維護服務',
      desc:''
    },
    lottery:{
      name:'彩票軟件系統及設備解決方案',
      desc:''
    },
  },
  marketing:{
    title:'營銷服務平台',
    platform_0:{
      name:'互娛權益平台',
      desc:''
    },
    platform_1:{
      name:'廣告營銷平台',
      desc:''
    },
    platform_2:{
      name:'SaaS服務平台',
      desc:''
    },
  },
  investor:{
    title:'投資者關系',
    noContent:'暂无内容',
    details:'詳情',
    back:'返回',
    loading:'加載中...',
    notice:{
      name:'公司通告',
      desc:'',
      files:{
        flie0:'正式通告',
        flie1:'組織章程細則',
        flie2:'會計師報告',
        flie3:'經審計合並財務報表',
        flie4:'衡力斯律師事務所編製的意見函',
        flie5:'開曼公司法',
        flie6:'中國法律意見書',
        flie7:'行業報告',
        flie8:'服務合同及委任函',
        flie9:'重大合約',
        flie10:'專家同意書',
        flie11:'公司章程',
        flie12:'審核委員會的職權範圍',
        flie13:'薪酬委員會的職權範圍',
        flie14:'提名委員會的職權範圍',
        flie15:'董事名單與其角色及職能',
        flie16:'股東提名候選董事的程序',
        flie17:'股東通訊政策',
      }
    },
    file:{
      name:'招股文件',
      desc:'',
      files:{
        flie0:'全球發售',
        flie1:'申請表格',
        flie2:'發售價及配發結果公告',
      }
    },
    report:{
      name:'定期報告',
      desc:'',
      files:{
        flie0:'月報表 - 截至2022年10月31日止股份發行人的證券變動月報表',
      }
    },
    news:{
      name:'公司新聞',
      desc:''
    },
    telephone:{
      name:'投資者熱線',
      desc:'',
      address:'杭州市富陽區銀湖創新中心8號樓2層'
    },
  },
  aboutUs:{
    title:'關于我們',
    contact:{
      name:'聯系我們',
      desc:''
    },
    join:{
      name:'招賢納士',
      desc:''
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-tw.js